import { type IntlShape } from "react-intl";
import { z } from "zod";

import { machineSecurePrintConfiguration } from "../machine-secure-print-configuration";
import { machineTypeSchema } from "../machine-type";
import { machineWithCorrugateTracksWithToleranceSchema } from "../machine-with-corrugate-tracks";
import { getMachineRequestBaseSchema, type MachineRequestBase } from "../machine-request-base";

const plcTrackSettingsSchema = z.object({
	installed: z.boolean(),
	materialBrand: z.string().optional(),
	materialWidth: z.number().optional(),
	materialThickness: z.number().optional(),
	isEmpty: z.boolean(),
});

const plcSettingsSchema = z.object({
	track1: plcTrackSettingsSchema.optional(),
	track2: plcTrackSettingsSchema.optional(),
	track3: plcTrackSettingsSchema.optional(),
});

export const getPl1MachineRequestSchema = (intl: IntlShape, existingMachines: MachineRequestBase[] = []) =>
	getMachineRequestBaseSchema(intl, existingMachines).extend({
		machineType: z.literal(
			machineTypeSchema.enum.PL1,
			intl.formatMessage({ id: "Machine type is invalid", defaultMessage: "Machine type is invalid" }),
		),
		securePrintConfiguration: machineSecurePrintConfiguration,
		plcSettings: plcSettingsSchema.optional(),
		tracks: machineWithCorrugateTracksWithToleranceSchema.shape.tracks.optional(),
	});

export type PL1MachineRequest = z.infer<ReturnType<typeof getPl1MachineRequestSchema>>;
